import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { CustomersApi } from '@tfs/tool-library-library-api';

import { AccountResetProgress } from '../models/account-reset.models';

/** HTTP for the owner's reset of their own account (Library API `customers/reset`). */
@Injectable({
  providedIn: 'root',
})
export class AccountResetApi {
  private readonly customersApi = inject(CustomersApi);

  /** Requests the reset, or resumes a failed one. Only the account owner may. */
  resetAccount(): Observable<void> {
    return this.customersApi.resetOwnAccount().pipe(map(() => undefined));
  }

  /** The latest reset, or null (204) when there is none — also briefly after `resetAccount`. */
  getProgress(): Observable<AccountResetProgress | null> {
    return this.customersApi.getOwnAccountResetProgress().pipe(map(progress => progress ?? null));
  }
}
